export const isLocalUserAnonymous = () => {
    return !window.APP.user;
};
